import validateNpmPackageName from 'validate-npm-package-name';

export interface PackageData {
    packageName: string;
    packageVersion: string;
}

// Validates package name
// Uses validate-npm-package-name which ensures:
// - No path traversal patterns (../, ./, etc.)
// - Slashes only in valid scoped packages (@scope/package)
// - Valid npm naming conventions
export function isValidPackageName(packageName: string): boolean {
    const validation = validateNpmPackageName(packageName);
    // Accept both new and legacy naming conventions (e.g., legacy packages like 'JSONStream' have uppercase)
    return validation.validForNewPackages || validation.validForOldPackages;
}

// Validates an array of packages and returns invalid package names.
// Returns null if all packages are valid, or an array of invalid package names.
export function getInvalidPackageNames(packages: PackageData[]): string[] | null {
    const invalidNames = packages
        .filter(pkg => !isValidPackageName(pkg.packageName))
        .map(pkg => pkg.packageName);

    return invalidNames.length > 0 ? invalidNames : null;
}

// Validates package paths to prevent path traversal attacks.
// Returns null if all paths are valid, or an array of invalid paths.
export function getInvalidPackagePaths(paths: string[]): string[] | null {
    const invalidPaths = paths
        .filter(path => path && (path.includes('../') || path.includes('..\\')))
        .map(path => path);

    return invalidPaths.length > 0 ? invalidPaths : null;
}

